module.exports = __webpack_public_path__ + "d561b4141b5356c4de75b423e048b32c.png"


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/images/NTPtour_image01.png
 ** module id = 169
 ** module chunks = 0
 **/